import LogoOpenAI from "../../../../assets/icons/LogoOpenAI";

import "./ReplyErrorState.scss";

const ReplyErrorState = ({ replyError }) => {
  return (
    <div className={"reply_error_state "}>
      <div className="avatar">
        <div className="openai_avatar">
          <LogoOpenAI color="#fff" />
        </div>
      </div>
      <div className="message_item">
        <div>{replyError.message}</div>
      </div>
    </div>
  );
};

export default ReplyErrorState;
